// About.jsx

import React from "react";
import "./OurServices.css";
import { Link } from "react-router-dom";







export default function OurServices() {


  const items = [
    { title: " איטום גגות- יריעות ביטומניות", img: "/images/43.jpg", path: "/Roof_waterproofing_bituminous_sheets"},
    { title: "  זיפות וסיוד גגות", img: "/images/17.jpg" , path: "/Roof_tar_and_plastering"},
    { title: " איטום קירות תת קרקעים בהתזה / יריעות ביטומניות", img: "/images/44.jpg" , path: "/Spray_sealing_of_ground_walls"},
    { title: "   איטום חדרים רטובים   ", img: "/images/45.jpg", path: "/Sealing_Wet_Rooms"},
    { title: " התקנת תשתיות בגובה", img: "/images/5.jpg", path: "/Installation_of_high_altitude_infrastructures"},
    { title: " יציקת בטקל", img: "/images/46.jpg", path: "/Betkal_Casting"},
    { title: "   איטום גגות מרוצפים בשיטה חדשנית", img: "/images/47.jpg", path: "/Sealing_tiled_roofs_using_an_innovative_method"},
    { title: " איטום מעטפת הבית    ", img: "/images/48.jpg", path: "/Sealing_the_house_envelope"},
    { title: "  פתרון ותיקון תקלות במערכות איטום קיימות", img: "/images/49.jpg", path: "/Solving_and_repairing_malfunctions_in_existing_sealing_systems"},
    { title: "  זיהוי מקורות רטיבות", img: "/images/50.jpg" , path: "/Identifying_moisture_sources"},
    { title: "   קידוחי יהלום   ", img: "/images/51.jpg" , path: "/Diamond_Drilling"},
    { title: " עבודות צביעה למטרת איטום", img: "/images/52.jpg" , path: "/Painting_work_for_the_purpose_of_sealing"},
    { title: " איטום גגות ע'י יריעות P.V.C", img: "/images/53.jpg" , path: "/Waterproofing_roofs_with_PVC_sheets"},
    { title: "   איטום מבנים תת-קרקעיים", img: "/images/54.jpg" , path: "/Sealing_underground_structures"},
    { title: "    איטום בהתזת פוליאוריטן טהור ", img: "/images/55.jpg" , path: "/Roof_sealing_with_pure_polyurethane_spraying"},
    { title: "איטום סביב חלונות במגוון פתרונות  ", img: "/images/56.jpg" , path: "/Sealing_around_windows_in_a_variety_of_solutions"},
    { title: "  ניקיון חלונות ומבנים בסנפלינג", img: "/images/57.jpg" , path: "/Cleaning_windows_and_buildings_in_abseiling"},
  ];







  return (

    <div className="OurServices-page">
      <div className="OurServices-hero">
        <div className="OurServices-overlay">
          <h1>  השירותים שלנו</h1>
        </div>

<div>




</div>


</div>

    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו</Link>
</div>



      <div className="grid3">
        {items.map((item, index) => (

           
            <Link to={item.path} key={index} className="card3">

              <img src={item.img} alt={item.title} />

              <div className="card3-btn">
                {item.title}
              </div>

            </Link>
        ))}
      </div>
    </div>


      </div>
  );
}


